export const UserAttributesFilterState = () => ({
  page: 1,
  perPage: 10,
  startDate: null,
  endDate: null,
});
